export default class PuntoRitiro {
	id           : Number;
	stato        : string;
	nome         : string;
	localita     : string;
	indirizzo    : string;
	tel          : string;
	map          : string;
	web          : string;
	consegna     : string;
	metodi       : string;
	im_url       : string;
	galleria     : string[];
	contributo   : Number;
	spedizione   : Number;
	testo_sped   : string;
	gap          : Number;
	tipi_pagam   : string[];
	soglia_gratis: Number;
}


// WEBPACK FOOTER //
// ./src/definitions/punto-ritiro.class.ts